import Vue from 'vue'
import Router from 'vue-router'

/**
 * 重写路由的push方法;解决重复点击同一个路由报错问题
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
};

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/check'  //首页默认跳转到IndexHouse
    },

    //  {
    //   path:'/home',
    //   name:'home',
    //   component:()=>import('@/views/home/Home'),
    //    meta: {title: '自述文件'},
    //    children: [
    //      {
    //        path: '/dashboard',
    //        component: () => import('@/views/index/Index'),
    //        meta: {title: '系统首页'}
    //      },
    //      {
    //        path: '/chanpass',
    //        component: () => import('@/views/extra/Chanpass'),
    //        meta: {title: '密码修改'}
    //      },
    //    ]
    // },

    {
      path:'/layout',
      name:'layout',
      component:()=>import('@/views/layout/Index'),
      meta: {title: '自述文件'},
      children: [
        //B2C
        {
          path: '/check',
          component: () => import('@/views/b2c/check/Index'),
          meta: {title: '验收产品',keepAlive: true}
        },
        {
          path: '/cancel',
          component: () => import('@/views/b2c/cancel/Index'),
          meta: {title: '作废拣货列表',keepAlive: true}
        },
        {
          path: '/put',
          component: () => import('@/views/b2c/up/PutOn'),
          meta: {title: '多品上架',keepAlive: true}
        },
        {
          path: '/pickIndex',
          component: () => import('@/views/b2c/pick/PickIndex'),
          meta: {title: '分区选择',keepAlive: true}
        },
        {
          path: '/pickList',
          component: () => import('@/views/b2c/pick/PickList'),
          meta: {title: '拣货列表'}
        },
        {
          path: '/menu',
          component: () => import('@/views/menu/Menu'),
          meta: {title: '菜单'}
        },
        /*{
          path: '/multi',
          component: () => import('@/views/multi/Multi'),
          meta: {title: '多品'}
        },*/
        /*{
          path: '/multi-list',
          component: () => import('@/views/multi/List'),
          meta: {title: '多品列表'}
        },*/

          // B2B
        {
          path: '/b2b-check',
          component: () => import('@/views/b2b/B2bCheck'),
          meta: {title: '验收产品',keepAlive: true}
        },

        {
          path: '/pending',
          // component: () => import('@/views/pending/Index'),
          component: () => import('@/views/pending/Index'),
          meta: {title: '待审核上架'}
        },

          //货架多品到齐列表
        /*{
          path: '/shelf',
          component: () => import('@/views/b2c/Shelf'),
          meta: {title: '查询货架完成订单'}
        },*/
        /*{
          path: '/shelf-list',
          component: () => import('@/views/b2c/List'),
          meta: {title: '多品列表'}
        },*/
        {
          path: '/annex-pick',
          component: () => import('@/views/b2c/annex/PickList'),
          meta: {title: '捡卡列表',keepAlive: true}
        },
        {
          path: '/annex-up',
          component: () => import('@/views/b2c/annex/UpList'),
          meta: {title: '上卡列表',keepAlive: true}
        },
        {
          path: '/warehouse-delivery',
          component: () => import('@/views/warehouse/delivery/Index'),
          meta: {title: '快递签收',keepAlive: true}
        },
      ]
    },

    {
      path: '/detail',
      component: () => import('@/views/b2c/detail/Detail'),
      meta: {title: '详情'}
    },

    {
      path: '/b2b-detail',
      component: () => import('@/views/b2b/B2bDetail'),
      meta: {title: 'B2B详情'}
    },

    {
      path: '/pending-form',
      component: () => import('@/views/pending/Form'),
      meta: {title: '待审核上架'}
    },

    {
      path:'/login',
      name:'Login',
      component:()=>import('@/views/login/login')

    },
    /*{
      path: '/register',
      name: 'Register',
      component: () => import('@/views/register/Register')
    },*/

  ]
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/register') {
    next();
  } else {
    let token = localStorage.getItem('access_token');
    // console.log(token)
    if (token === null || token === '') {
      // 修改了跳转到主页
      next('/login');
    } else {
      next();
    }
  }
});
export default router
